export default {
  en: {
    timestampFormat: 'dd MMM yyyy',
    error: 'Failed to load organisation details',
    retry: 'Retry',
    menu: {
      basicInfo: 'Basic info',
      invite: 'Invite details',
      products: 'Products and services',
      criticalSuppliers: 'Critical suppliers',
    },
    basicInfo: {
      title: 'Basic info',
      desc: 'The essential information about this organisation.',
      legalName: 'Legal name',
      companyNumber: 'Company number',
      tradingNames: 'Trading names',
      website: 'Website',
    },
    location: {
      title: 'Location',
      desc: 'The address of the registered office for this organisation.',
      streetAddress: 'Street address',
      city: 'City',
      postCode: 'Post code',
      country: 'Country',
    },
    invite: {
      title: 'Invite details',
      desc: 'Information about the original invite sent to this supplier, asking them to join Risk Ledger.',
      inviteName: 'Invite name',
      inviteEmail: 'Invite email',
      invitedBy: 'Invited by',
      invitedOn: 'Invited on',
      status: 'State',
      acceptedOn: 'Accepted on',
      statuses: {
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
        expired: 'Expired',
      },
      deletedUser: 'Deleted user',
    },
    connectionRequest: {
      title: 'Connection request details',
      contactEmail: 'Contact email',
      sentBy: 'Sent by',
      sentOn: 'Sent on',
      status: 'State',
      acceptedOn: 'Accepted on',
      statuses: {
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
        expired: 'Expired',
      },
    },
    products: {
      title: 'Products and services',
      desc: 'These products and services are offered by {0}. If you use any of these, go to the overview page to add them to your connection.',
    },
    criticalSuppliers: {
      title: 'Critical suppliers',
      desc: 'These suppliers have been highlighted by {supplierName} as suppliers critical to their business.',
      placeholder: {
        title: 'No critical suppliers',
        description:
          'This supplier has not highlighted any suppliers as critical to their business.',
      },
      view: 'View on network map',
      sector: 'Sector',
      country: 'Country',
      action: 'Action',
      name: 'Name',
      connectedAt: 'Date added',
      export: 'Export',
      dateFormat: 'yyyy-MM-dd',
      filename: 'Critical_suppliers_of_{supplierName}',
      unconfirmed: 'Unconfirmed',
      unconfirmedCallout:
        'Some of these critical suppliers have been automatically found and have not been confirmed by the supplier',
    },
    managed: {
      title: 'RL managed',
      description: 'This profile has been created and is managed by Risk Ledger.',
    },
    basic: {
      title: 'Basic access',
      description: 'This supplier has not granted you full access to their profile.',
    },
    full: {
      title: 'Full access',
      description: 'You have full access to review and interact with this supplier.',
    },
    unclaimed: {
      title: 'Unclaimed',
      description: 'This supplier has not signed up to Risk Ledger.',
    },
    clientManaged: {
      title: 'Client-managed',
      description: "Your organisation is answering this supplier's assessment on their behalf.",
    },
  },
};
